import { createContext } from "react";

interface MetaIntroTranslation {
  published: string;
  notYetPublished: string;
  moreInformation: string;
  openPdf: string;
  copyLink: string;
  pageType: string;
  olderVersions: string;
  doi: string;
  cite: string;
  contact: string;
  copyright: string;
  imageCredits: string;
  references: string;
  copyCitation: string;
  copyDoi: string;
  copied: string;
  otherLanguages: string;
}

interface FigureTranslation {
  expand: string;
  viewSource: string;
}

interface CitationTranslation {
  viewSource: string;
}

interface ReadingCompanionTranslation {
  outline: string;
  citations: string;
  figures: string;
}

interface VideoEmbedTranslation {
  consent: string;
}

interface ExcursionCardTranslation {
  see: string;
}

interface CitationsTranslation {
  citations: string;
}

interface GlossaryTranslation {
  glossary: string;
}

interface ProjectPage {
  toTopic: string;
}

interface Legal {
  imprint: string;
  privacy: string;
}

export interface ITranslationContext {
  metaIntro: MetaIntroTranslation;
  figure: FigureTranslation;
  citation: CitationTranslation;
  readingCompanion: ReadingCompanionTranslation;
  videoEmbed: VideoEmbedTranslation;
  excursionCard: ExcursionCardTranslation;
  citations: CitationsTranslation;
  glossary: GlossaryTranslation;
  projectPage: ProjectPage;
  legal: Legal;
}

export const TranslationContext = createContext<ITranslationContext | null>(
  null,
);
